import React from 'react'
import PaperCardList from '../../../Container/Content/PaperCardList'
import {getRoleName} from '../../../js/helper'

const UserProfile = props => {
    const { userData } = props
    const userProfileProperties = {
        headline: 'Benutzerprofil',
        withLable: true,
        content: {
            name: {
                lable: 'Name',
                value: userData.name
            },
            rolle: {
                lable: 'Rolle',
                value: getRoleName(userData.role)
            },
            email: {
                lable: 'Email',
                value: userData.email
            },
            telefon: {
                lable: 'Telefon',
                value: userData.telefon
            },
            strasse: {
                lable: 'Straße',
                value: userData.strasse
            },
            ort: {
                lable: 'Ort',
                value: userData.ort
            }
        }
    }



    

    return (
            <PaperCardList renderProps={userProfileProperties} />
    )

}


export default UserProfile



// WEBPACK FOOTER //
// ./src/Components/UserAuth/UserAccount/UserProfile.js